import React from "react";

type Product = {
  productId: string;
  displayName: string;
};

type Props = {
  title: string;
  bucket: "insa" | "general";
  products: Product[];
  selected: {
    bucket: "insa" | "general";
    productId: string;
  } | null;
  onSelect: (bucket: "insa" | "general", product: Product) => void;
  isDisabled: (productId: string) => boolean;
};

const Bucket: React.FC<Props> = ({ title, bucket, products, selected, onSelect, isDisabled }) => {
  return (
    <div className="mb-10 rounded-xl border border-gray-200 bg-white p-6">
      <h2 className="text-lg font-semibold mb-6 text-gray-800">{title}</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {products.map((p) => {
          const isSelected = selected?.productId === p.productId;
          const disabled = isDisabled(p.productId);

          return (
            <div
              key={p.productId}
              onClick={() => !disabled && onSelect(bucket, p)}
              className={`
    rounded-xl border-2 p-4 cursor-pointer transition-all
    flex items-center
    ${isSelected ? "border-blue-600 bg-blue-50 shadow-md" : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-sm"}
    ${disabled ? "opacity-40 pointer-events-none" : ""}
  `}
            >
              <p className="font-medium text-gray-800 text-left">{p.displayName}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Bucket;
